Dashboard = Object.assign({ }, window.Dashboard || { }, {
    NestedDropdown: {
        init: function($, window, document) {
            var $nestedItems = $('.nested-dropdown__submenu-item');
            var $nestedItemsTriggers = $('.nested-dropdown__submenu-item__link');

            $nestedItemsTriggers.on('click', function(e) {
                e.stopImmediatePropagation();

                var $trigger = $(this);
                var $parent = $trigger.parent('.nested-dropdown__submenu-item');

                $nestedItems
                    .not($parent)
                    .removeClass('nested-dropdown__submenu-item--open');

                $parent
                    .toggleClass('nested-dropdown__submenu-item--open');
            });
        }
    }
});